import classNames from "classnames";
import { Button } from "./Button";
import { ButtonProps } from "./Button.types";

/** The white, grey-bordered button the page builder uses to back out. */
export function CancelButton({
  text = "Cancel",
  className,
  ...props
}: Omit<ButtonProps, "variant">) {
  return (
    <Button
      {...props}
      text={text}
      className={classNames(
        "border rounded-2 bg-white text-dark fw-medium hover-bg-light",
        className
      )}
    />
  );
}

export default CancelButton;
